import { Transition } from "../../../../core/flows/Transition";
import { SearchContext } from "../Context/SearchContext";

export class FMLMSearchTransition extends Transition {
  constructor(entryStep: string, exitSteps: string[]) {
    super(entryStep, exitSteps);
  }

  onExecute(): string[] {
    console.log("-------- FmlmSearchTransition executed");

    const context = this.getCtx<SearchContext>("searchContext", this.entryStep);
    if (!context) {
      console.log("[Transition] No choice data available, using default exits");
      return this.exitSteps;
    }

    if (!(context.routeTo ?? []).every((step) => this.exitSteps.includes(step))) {
      console.log(`[Transition] Invalid choice: ${context.routeTo}`);
      return [];
    }

    return [...(context?.routeTo ?? [])];
  }
}